import React, { Component } from 'react';
import Dashboard from '../Dashboard/Dashboard';
import Header from '../Header/Header';
import About from '../About/About';
import Windows from '../Windows/Windows';
import Doors from '../Doors/Doors';
import Roofing from '../Roofing/Roofing';
import Painting from '../Painting/Painting';
import Gutters from '../Gutters/Gutters';
import Stucco from '../Stucco/Stucco';
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import UnderConstruction from '../UnderConstruction/UnderConstruction';
import './App.css';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';


class App extends Component {
  render() {
  return (
  <ScrollToTop>
    <div class="App">
      <Header/>
      <Routes>
        <Route path="/" element={<Dashboard />}/>
        <Route path="/windows" element={<Windows/>}/>
        <Route path="/roofing" element={<Roofing/>}/>
        <Route path="/doors" element={<Doors/>}/>
        <Route path="/painting" element={<Painting/>}/>/>
        <Route path="/gutters" element={<Gutters/>}/>/>
        <Route path="/stucco" element={<Stucco/>}/>/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<UnderConstruction/>}/>/>
        <Route path="*" element={<Dashboard />} />
      </Routes>

    </div>
    </ScrollToTop>
  )
};
}

export default App;
